/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

// export const getStoryType = (state) => isObj(state, 'storyType', []);
export const getAllCmsStories = (state) => isObj(state, 'stories', []);
// export const getStoryById = (state) => isObj(state, 'story', []);
